import { Howler, Howl } from 'howler';

// Enhanced Howl with auto-cleanup on end/stop/pause to prevent iOS audio conflicts
// Uses Web Audio API (html5: false) to avoid RecordRTC recording conflicts
class ManagedHowl extends Howl {
    constructor(o = {}) {
        const { onhalt, onwillunload, unloadOnEnd = true, ...delegated } = o;
        super({ html5: false, ...delegated });

        this._onhalt = onhalt ? [{ fn: onhalt }] : [];
        this._onwillunload = onwillunload ? [{ fn: onwillunload }] : [];

        this.on('end', () => {
            this._emit('halt', null);
            if (unloadOnEnd && !o.loop) this.unload();
        });
        this.on('stop', () => this._emit('halt', null));
        this.on('pause', () => this._emit('halt', null));
    }

    unload() {
        this._emit('willunload', null);
        super.unload();
    }
}

export { Howler, Howl, ManagedHowl };
export default ManagedHowl;
